module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fzg-join-detail-mobile"
  }, [_c('div', {
    staticClass: "fzg-banner"
  }, [_c('fzg-menu'), _vm._v(" "), _c('img', {
    staticClass: "m-banner",
    attrs: {
      "src": require("../../assets/img2/mobile/join/banner.jpg"),
      "alt": ""
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "fzg-job-detail"
  }, [_c('div', {
    staticClass: "jd-title"
  }, [_c('div', {
    staticClass: "title-text"
  }, [_vm._v(_vm._s(_vm.jobDetail.title))])]), _vm._v(" "), _c('div', {
    staticClass: "jd-desc"
  }, [_c('div', {
    staticClass: "type-title"
  }, [_vm._v("【岗位职责】")]), _vm._v(" "), _c('div', {
    staticClass: "jd-content"
  }, [_vm._v(" " + _vm._s(_vm.jobDetail.jd) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "jd-requirement"
  }, [_c('div', {
    staticClass: "type-title"
  }, [_vm._v("【职位要求】")]), _vm._v(" "), _c('div', {
    staticClass: "jd-content"
  }, [_vm._v(" " + _vm._s(_vm.jobDetail.requirement) + " ")])])]), _vm._v(" "), (false) ? _c('div', {
    staticClass: "fzg-job-detail"
  }, [_vm._m(0, false, false), _vm._v(" "), _vm._m(1, false, false), _vm._v(" "), _vm._m(2, false, false)]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "jd-title"
  }, [_c('div', {
    staticClass: "title-text"
  }, [_vm._v("凡卓集团-凡卓资本-分析师/高级分析师")]), _vm._v(" "), _c('a', {
    staticClass: "send-email-btn",
    attrs: {
      "href": "mailto:hr@xfz.cn"
    }
  }, [_vm._v("投递简历")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "jd-desc"
  }, [_c('div', {
    staticClass: "type-title"
  }, [_vm._v("【岗位职责】")]), _vm._v(" "), _c('div', {
    staticClass: "jd-content"
  }, [_c('ul', [_c('li', [_vm._v(" 在融资项目协作中提供PPT/图表制作支持、强逻辑梳理、快速响应； ")]), _vm._v(" "), _c('li', [_vm._v(" 根据公司确定的投资方向，开展市场及行业研究，深入了解行业现状，分析梳理产业链，撰写行业分析报告；")]), _vm._v(" "), _c('li', [_vm._v(" 寻找优秀创业者及创业团队，与之建立良好的沟通及合作关系；")]), _vm._v(" "), _c('li', [_vm._v(" 辅助创业团队梳理商业模式建议及融资方案；")]), _vm._v(" "), _c('li', [_vm._v(" 把控项目中可能出现的风险，促成交易圆满，提升项目成交率。")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "jd-requirement"
  }, [_c('div', {
    staticClass: "type-title"
  }, [_vm._v("【职位要求】")]), _vm._v(" "), _c('div', {
    staticClass: "jd-content"
  }, [_c('ul', [_c('li', [_vm._v(" 在融资项目协作中提供PPT/图表制作支持、强逻辑梳理、快速响应； ")]), _vm._v(" "), _c('li', [_vm._v(" 根据公司确定的投资方向，开展市场及行业研究，深入了解行业现状，分析梳理产业链，撰写行业分析报告；")]), _vm._v(" "), _c('li', [_vm._v(" 寻找优秀创业者及创业团队，与之建立良好的沟通及合作关系；")]), _vm._v(" "), _c('li', [_vm._v(" 辅助创业团队梳理商业模式建议及融资方案；")]), _vm._v(" "), _c('li', [_vm._v(" 把控项目中可能出现的风险，促成交易圆满，提升项目成交率。")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1079b323"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/join/FzgJoinDetailMobile.vue
// module id = 215
// module chunks = 0